import type {Nullish} from 'shared/web';

import {toBoundedAssistantBusinessCaseText} from './toBoundedAssistantBusinessCaseText';

const RAW_CATALOGUE_KEY_PATTERN = /(?:^|-)(?:MAKE|MODELFAMILY)_/;

export const toResolvedBusinessCaseVehicleLabel = (value: string | Nullish) =>
  toBoundedAssistantBusinessCaseText(
    value
      ?.split(' ')
      .filter((part) => !RAW_CATALOGUE_KEY_PATTERN.test(part))
      .join(' ')
  );
